import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';

import messagesHu from 'node_modules/devextreme/localization/messages/hu.json';
import { formatMessage, loadMessages, locale } from 'devextreme/localization';

import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom, Subscription } from 'rxjs';
import { Coupon } from '../module-subscription/subscription-models';
import { SubscriptionService } from '../module-subscription/subscription-service';
import { BoolResult } from '../module-thryve/thryve.service';

/**
 * Kuponok karbantartása. (admin szerepkörrel)
 */

@Component({
  selector: 'app-coupon',
  standalone: false,
  templateUrl: './coupon.html',
  styleUrl: './coupon.scss',
})
export class CouponComponent implements OnInit, OnDestroy {

  coupons: Coupon[] = [];
  compareMessage!: string;
  error: string;
  baseUri: string = `${environment.apiUrl}`;
  dataSource: any;
  private translSubs$: Subscription = new Subscription;
  isInsertMode = false;


  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private subscriptionService: SubscriptionService,
    private translation: L10nTranslationService,
  ) {
    this.asyncCouponCodeValidation = this.asyncCouponCodeValidation.bind(this);
    const huMessages = JSON.stringify(messagesHu['hu']);
    loadMessages({
      'hu': JSON.parse(huMessages)
    });

    this.dataSource = new CustomStore({
      key: "couponId",
      load: () => this.getAll(),
      insert: async (values) => {

        try {

          await firstValueFrom(
            this.subscriptionService.insertCoupon(values)
          );

          return;

        } catch (err: any) {

          throw err.error?.message ??
                err.error?.title ?? err.error?.message ??
                'Mentési hiba';
        }
      },
      update: (key, values) => this.update(key, JSON.stringify(values)),
      remove: (key) => this.delete(key).then()
    });
  }


  ngOnInit(): void {
    this.translSubs$ = this.translation.onChange().subscribe(
      x => {
        locale(x.language);
          //Start és end dátum összehasonlító hibaüzenet
        this.compareMessage = this.translation.translate('Core.ValidationDateGreaterError')
          .replace('{0}', this.translation.translate('Task.End'))
          .replace('{1}', this.translation.translate('Task.Start'));
    });
  }

  ngOnDestroy() {
    if (this.translSubs$) {
      this.translSubs$.unsubscribe();
    }
  }

  onInitNewRow(e: any) {
      this.isInsertMode = true;
  }

  onEditingStart(e: any) {
      this.isInsertMode = false;
  }  
  asyncCouponCodeValidation = function (params) {
    if (!this.isInsertMode) {
        return Promise.resolve(true);
    }

    let couponCode = params.value;
    let result: BoolResult = {} as BoolResult;
    return new Promise((resolve, reject) => {
      this.subscriptionService.isCouponCodeAvailable(couponCode).pipe(first()).subscribe({
        next: (v) => {
          result = v;
          params.rule.message = result.error;
        },
        error: (e) => reject(e.message),
        complete: () => resolve(result.result)
      })
    });

  }  

onRowValidating(e: any) {
    const validFrom = e.newData.validFrom ?? e.oldData.validFrom;
    const validTo = e.newData.validTo ?? e.oldData.validTo;

    if (validFrom && validTo && validTo <= validFrom) {
        e.isValid = false;
        e.errorText = 'A végdátumnak nagyobbnak kell lennie a kezdődátumnál';
    }
}

onEditorPreparing(e: any) {

  if (
      e.parentType === 'dataRow' &&
      e.dataField === 'couponId' &&
      !e.row?.isNewRow
     ) {

      e.editorOptions.readOnly = true;
  }
}
  getAll() {
    return new Promise((resolve, reject) => {
      this.subscriptionService.getCoupons().pipe(first()).subscribe({
        next: (v) => this.coupons = v,
        error: (e) => reject(e.message),
        complete: () => resolve(this.coupons)
      })
    });
  }


  insert(coupon: string) {
    let result: any;
    return new Promise((resolve, reject) => {
      this.subscriptionService.insertCoupon(coupon).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.statusText == "OK") {
            resolve("OK");
          } else {
            reject(result.errors[0].description);
          }
        }
      })
    });
  }

update (key, values) {

  return firstValueFrom(
    this.subscriptionService.updateCoupon(key, values)
  )
  .catch((err) => {

    throw err.error?.message ?? 
          'Mentési hiba';
  });
}

delete (key) {

  return firstValueFrom(
    this.subscriptionService.deleteCoupon(key)
  )
  .catch((err) => {

    throw err.error ?? 
          'Törlés nem lehetséges';
  });
}


}
